import React from 'react';
import {Platform} from "../../models";
import {Icon} from 'antd'

export default function ({platform}) {
  switch (platform) {
    case Platform.ANDROID:
      return <Icon type="android" />;
    
    case Platform.IOS:
      return <Icon type="apple" />;
      
    default:
      return <Icon type="desktop" />;
  }
}